import { Stack } from "@mui/material"

const CustomSpacer = ({ item, ...props }) => {

    return <Stack {...item?.props} />
};

export default CustomSpacer;